import { createApp, h } from "vue";
import KundenkontoNavigation from "@/components/Navigation/KundenkontoNavigation.vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import wrapper from "vue3-webcomponent-wrapper";

const navigationElement = wrapper(KundenkontoNavigation, createApp, h);
customElements.define("self-kundenkonto-navigation", navigationElement);
